// Single source of truth for FOUNDER-launch pricing/copy on user-facing
// surfaces. During the founder launch there is NO "Explorer Basic/Plus" or
// "Universe Pass" — everything is founder-branded. Keep every upsell, paywall,
// nudge and banner consistent by importing from here.
export const FOUNDER_PLANS = {
  basic: { id: "founder_basic", name: "Founder Basic", price: "Free", period: "forever" },
  plus: { id: "founder_individual", name: "Founder Plus", price: "$6.99", period: "/mo" },
  family: { id: "founder_family", name: "Founder Family Pass", price: "$12.99", period: "/mo" },
  familyYearly: { id: "founder_yearly", name: "Founder Family Pass (Yearly)", price: "$99.99", period: "/yr" },
  vip: { id: "founder_vip", name: "Founder VIP", price: "Invite-only", period: "lifetime" },
};

// The entry paid price we lead with in upsells during the founder launch.
export const FOUNDER_ENTRY = FOUNDER_PLANS.plus; // $6.99/mo Founder Plus

// Standard founder upsell copy used across nudges/paywalls.
export const FOUNDER_UPSELL = {
  eyebrow: "Founder Launch",
  headline: "Become a Founder",
  price: FOUNDER_ENTRY.price,
  period: FOUNDER_ENTRY.period,
  cta: "Become a Founder",
  subline: `Unlock the AI tutor, Forest Academy, Family Party Games & more — Founder Plus from ${FOUNDER_ENTRY.price}${FOUNDER_ENTRY.period}. Lock in lifetime founder pricing before launch.`,
};
